import React, { useEffect, useMemo } from 'react';
import {
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { MdExpandMore } from 'react-icons/md';
import { t } from '#i18n';
import { calculateDayDifference } from '#utils/duration';

const rangeOptions = [
  { days: 7, label: t('stats.dateRange.last7Days') },
  { days: 30, label: t('stats.dateRange.last30Days') },
  { days: 90, label: t('stats.dateRange.last90Days') },
  { days: 180, label: t('stats.dateRange.last180Days') },
  { days: 365, label: t('stats.dateRange.last365Days') },
];

export const DateRangePicker = ({ dateRange, onChange }) => {
  const { startDate, endDate } = dateRange;

  const range = useMemo(() => {
    if (!startDate || !endDate) return rangeOptions[0];
    const daysInRange = calculateDayDifference(endDate, startDate);
    return rangeOptions.find((option) => option.days >= daysInRange) || rangeOptions.at(-1);
  }, [startDate, endDate]);

  const handleRangeChange = (newRange) => {
    const newEndDate = new Date();
    newEndDate.setHours(23, 59, 59, 999);

    const newStartDate = new Date();
    newStartDate.setDate(newEndDate.getDate() - newRange.days);
    newStartDate.setHours(0, 0, 0, 0);

    onChange({ startDate: newStartDate, endDate: newEndDate });
  };

  useEffect(() => {
    if (!startDate || !endDate) {
      handleRangeChange(rangeOptions[0]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        minWidth={40}
        aria-label={t('stats.dateRange.buttonLabel')}
        backgroundColor="primary.400"
        borderColor="primary.300"
        variant="outline"
        fontWeight="normal"
        rightIcon={<MdExpandMore />}
      >
        {range.label}
      </MenuButton>
      <MenuList>
        {rangeOptions.map((option) => (
          <MenuItem
            key={option.days}
            aria-label={option.label}
            onClick={() => handleRangeChange(option)}
          >
            {option.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
